import { render, staticRenderFns } from "./transportation_detail.vue?vue&type=template&id=d4fe3b0a"
import script from "./transportation_detail.vue?vue&type=script&lang=js"
export * from "./transportation_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports